import {
  Box,
  Table,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Typography,
  Autocomplete,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import ModalHeader from "./ModalHeader";
import ModalFooter from "./ModalFooter";
import { Modal, Button } from "@mui/material";
import Loader from "../component/loading-screen/Loader";
import { get, postJsonData } from "../network/ApiController";
import ApiEndpoints from "../network/ApiEndPoints";
import { apiErrorToast, okSuccessToast } from "../utils/ToastUtil";
import AuthContext from "../store/AuthContext";
import { ddmmyy } from "../utils/DateUtils";
import { param } from "jquery";
import { string } from "prop-types";
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};
const AddBillers = ({ getBillers }) => {
  const [open, setOpen] = useState(false);
  const [request, setRequest] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [categoryName, setCategoryName] = useState(null);
  const [billers, setBillers] = useState([]);
  const [currentBiller, setCurrentBiller] = useState("");
  const [params, setParams] = useState([]);
  const [formData, setFormData] = useState({});
  const [fetchMandatory, setFetchMandatory] = useState("");
  const [progress, setProgress] = useState(false);
  const [billDate, setBillDate] = useState("");
  const [billDueDate, setBillDueDate] = useState("");
  const [billAmount, setBillAmount] = useState("");
  const [categoryKey, setCategoryKey] = useState("");
  const authCtx = useContext(AuthContext);
  const location = authCtx.location;
  const user = authCtx.user;
  const handleOpenModal = () => {
    setOpen(true);
    setBillDate("");
    setBillDueDate("");
    setBillAmount("");
  };

  const handleCloseModal = () => setOpen(false);

  const getCategories = () => {
    get(
      ApiEndpoints.BBPS_CATEGORIES,
      "pf=WEB",
      setRequest,
      (res) => setCategories(res.data.data),
      apiErrorToast
    );
  };

  const [categories, setCategories] = useState([]);

  const getBbpsBillers = (catKey) => {
    setBillers([]);
    setParams([]);
    setCurrentBiller("");
    postJsonData(
      ApiEndpoints.BBPS_GET_BILLERS,
      { categoryKey: catKey },
      setRequest,
      (res) => {
        let data = res.data.data.records;
        if (catKey === "C03") {
          data = data.filter((item) => item.type === "ONUS");
        }
        setBillers(data);
        setFetchMandatory("");
      },
      apiErrorToast
    );
  };

  const getBillersDetails = (billerId) => {
    postJsonData(
      ApiEndpoints.BBPS_GET_BILLERS_DETAILS,
      { billerId },
      setProgress,
      (res) => {
        const data = res.data.data;
        const categoryKey = data.category.key;
        setCategoryKey(categoryKey);
        console.log("categoryKey", categoryKey);
        const fields = data.parameters || [];

        if (
          categoryName?.categoryName === "Electricity" &&
          data?.parameters[1]?.desc !== "Mobile Number"
        ) {
          fields.push({
            name: "param2",
            desc: "Mobile Number",
            minLength: 10,
            maxLength: 10,
            inputType: "NUMERIC",
            mandatory: 1,
          });
        }

        if (data.fetchRequirement === "NOT_SUPPORTED") {
          fields.push({
            name: "amount",
            desc: "Amount",
            minLength: 2,
            maxLength: 7,
            inputType: "NUMERIC",
            mandatory: 1,
          });
        }

        setParams(fields);
        setFetchMandatory(data.fetchRequirement);
      },
      apiErrorToast
    );
  };

  const handleInputChange = (name, value) => {
    if (name === "param2" && value.length === 11 && value[0] === "0") {
      // Ensure it's treated as a string to preserve leading zero
      value = value.padStart(11, "0");
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    if (billDate || billDueDate || billAmount) {
      console.log("Updated Bill Details:", billDate, billDueDate, billAmount);
    }
  }, [billDate, billDueDate, billAmount]);
  const fetchBill = () => {
    const data = {
      billerId: currentBiller,
      latitude: location.lat,
      longitude: location.long,
      amount: 0,
    };

    for (let param of params) {
      let value = formData[param.name];

      if (param.mandatory === 1 && !value) {
        apiErrorToast(`Please fill out the field: ${param.desc}`);
        return;
      }

      // If the value is param1 (phone number), ensure it's a string
      if (param.name === "param1") {
        value = value.toString().trim(); // Ensure the value is treated as a string
      }

      // If the field is numeric (and it's not the phone number), convert to a number
      data[param.name] =
        param.inputType === "NUMERIC" && param.name !== "param1"
          ? Number(value)
          : value;
    }

    postJsonData(
      ApiEndpoints.BBPS_FETCH_BILL,
      data,
      setProgress,
      (res) => {
        const data = res?.data?.data?.data;
        setBillDate(data?.BillDate);
        setBillDueDate(data?.BillDueDate);
        setBillAmount(data?.BillAmount);
        console.log("Bill Details:", billDate, billDueDate, billAmount);
      },
      apiErrorToast
    );
  };

  useEffect(() => {
    getCategories();
  }, []);

  const addBiller = () => {
    const billerName =
      billers.find((b) => b.billerId === currentBiller)?.billerName || "";
    const formatDate = (date) => {
      const [day, month, year] = date?.split("/") || [null, null, null];
      if (!day || !month || !year) return null;

      return `${year}-${month}-${day}`;
    };

    const data = {
      param1: formData.param1,
      param2: formData.param2 ? formData.param2 : null,
      param3: billAmount ? parseInt(billAmount) : null,
      param4: formData.param3 ? formData.param3 : null,
      biller_id: currentBiller,
      biller_name: billerName,
      due_date: formatDate(billDueDate),
      generated_date: formatDate(billDate),
      categoryKey: categoryKey,
    };

    // for (let i = 0; i < params.length; i++) {
    //   const param = params[i];
    //   const value = formData[param.name];

    //   if (param.mandatory === 1 && !value) {
    //     apiErrorToast(`Please fill out the field: ${param.desc}`);
    //     return;
    //   }
    //   if (i === 3) {
    //     data[param.name] = billAmount;
    //   } else if (i === 4) {
    //     const formattedDate = new Date(value).toISOString().split("T")[0];
    //     data[param.name] = formattedDate;
    //   } else {
    //     data[param.name] = value?.toString() || "";
    //   }
    // }

    postJsonData(
      ApiEndpoints.ADD_MY_BILLER,
      data,
      setProgress,
      (res) => {
        const responseData = res?.data?.data?.data;

        okSuccessToast(res.data.message);
        getBillers();
      },
      (error) => {
        apiErrorToast(error);
      }
    );

    handleCloseModal();
  };

  console.log("the user id ", user.id);
  return (
    <Box sx={{ backgroundColor: "#f5f7fa", borderRadius: 2, p: 2 }}>
      <Button
        style={{
          backgroundColor: "#007bff",
          border: "none",
          padding: "6px 12px",
          color: "#fff",
          borderRadius: 5,
        }}
        onClick={handleOpenModal}
      >
        Add Biller
      </Button>

      <Modal open={open} onClose={handleCloseModal}>
        <Box sx={modalStyle}>
          <Loader loading={request || progress} />
          <ModalHeader title="Add Biller" handleClose={handleCloseModal} />

          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel>Select Biller Category</InputLabel>
            <Select
              value={selectedCategory}
              onChange={(e) => {
                const catKey = e.target.value;
                const selected = categories.find(
                  (c) => c.categoryKey === catKey
                );
                setSelectedCategory(catKey);
                setCategoryName(selected);
                getBbpsBillers(catKey);
              }}
              label="Select Biller Category"
            >
              {categories.map((item) => (
                <MenuItem key={item.categoryKey} value={item.categoryKey}>
                  {item.categoryName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Autocomplete
            options={billers}
            getOptionLabel={(option) => option.billerName}
            value={
              billers.find((biller) => biller.billerId === currentBiller) ||
              null
            }
            onChange={(event, newValue) => {
              if (newValue) {
                setCurrentBiller(newValue.billerId);
                getBillersDetails(newValue.billerId);
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Service Provider"
                variant="outlined"
              />
            )}
            fullWidth
            sx={{ mt: 2 }}
          />

          {params.length > 0 && (
            <Box sx={{ mt: 2 }}>
              {params.map((field, idx) => (
                <TextField
                  key={idx}
                  fullWidth
                  label={field.desc}
                  value={formData[field.name] || ""}
                  onChange={(e) =>
                    handleInputChange(field.name, e.target.value)
                  }
                  inputProps={{
                    minLength: field.minLength,
                    maxLength: field.maxLength,
                    inputMode:
                      field.inputType === "NUMERIC" ? "numeric" : "text",
                  }}
                  sx={{ mb: 2 }}
                />
              ))}
              {billDate && billDueDate && billAmount ? (
                <>
                  <TextField
                    fullWidth
                    label="Bill Date"
                    value={billDate ?? "null"}
                    InputProps={{ readOnly: true }}
                    sx={{ mb: 2 }}
                  />
                  <TextField
                    fullWidth
                    label="Due Date"
                    value={billDueDate ?? "null"}
                    InputProps={{ readOnly: true }}
                    sx={{ mb: 2 }}
                  />
                  <TextField
                    fullWidth
                    label="Bill Amount"
                    value={billAmount ?? "null"}
                    InputProps={{ readOnly: true }}
                    sx={{ mb: 2 }}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={addBiller}
                  >
                    Add Biller
                  </Button>
                </>
              ) : (
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={fetchBill}
                >
                  Fetch Bill
                </Button>
              )}
            </Box>
          )}
        </Box>
      </Modal>
    </Box>
  );
};

export default AddBillers;
